import React from "react";
import "./css/AboutUs.css"; // Reusing shared CSS
import pictureOne from "./assets/picOne.png";

const IndustrialResearchTraining = () => {
  return (
    <div className="about-us">
      {/* === Header Section === */}
      <section className="about-header research-header">
        <div className="overlay">
          <h1 className="page-title">Industrial Research and Training</h1>
          <p className="subtitle">
            Empowering industry through research, innovation, and professional training in Malawi.
          </p>
        </div>
      </section>

      {/* === Introduction Section === */}
      <section className="intro-section">
        <div className="intro-card">
          <h2>About Industrial Research and Training</h2>
          <p>
            The Industrial Research and Training Department of the Malawi Bureau of Standards (MBS) focuses on applied research, 
            testing, and training programs that enhance industrial processes, improve product quality, and ensure compliance 
            with national and international standards.
          </p>
        </div>

        <div className="intro-card">
          <h2>Our Commitment</h2>
          <p>
            MBS is committed to fostering innovation, providing practical technical guidance, and building the capacity of 
            industry personnel through specialized training and research-driven insights.
          </p>
        </div>
      </section>

      {/* === Core Functions Section === */}
      <section className="functions-section">
        <h2>Core Functions</h2>
        <ul>
          <li>
            <strong>Industrial Research:</strong> Conducting research to improve manufacturing processes, product performance, 
            and compliance with standards.
          </li>
          <li>
            <strong>Training Programs:</strong> Offering workshops, seminars, and professional courses for industry staff 
            on quality management and standardization.
          </li>
          <li>
            <strong>Innovation Support:</strong> Assisting companies in adopting new technologies and improving production methods.
          </li>
          <li>
            <strong>Collaboration with Institutions:</strong> Partnering with universities, research institutes, and industry 
            players to enhance technical knowledge and capacity.
          </li>
          <li>
            <strong>Capacity Building:</strong> Strengthening technical and managerial skills of personnel across industries.
          </li>
        </ul>
      </section>

      {/* === Background and Mandate === */}
      <section className="background-section">
        <div className="text-content">
          <h2>Background</h2>
          <p>
            The Malawi Bureau of Standards (MBS) was established in 1972 as a statutory body to promote standards, quality, 
            and industrial research. The Industrial Research and Training Department plays a vital role in ensuring the 
            technical advancement of Malawi’s industries.
          </p>

          <h2>Mandate</h2>
          <p>
            To provide research, training, and technical support services that help industries comply with standards, 
            improve production quality, and adopt innovative solutions.
          </p>
        </div>

        <div className="image-content">
          <img src={pictureOne} alt="Industrial Research and Training" />
        </div>
      </section>

      {/* === Benefits Section === */}
      <section className="benefits-section">
        <h2>Benefits of Industrial Research and Training</h2>
        <ul>
          <li>Enhances industrial efficiency and productivity.</li>
          <li>Improves product quality and compliance with standards.</li>
          <li>Develops skilled workforce through technical training.</li>
          <li>Supports innovation and adoption of new technologies.</li>
          <li>Promotes competitiveness of Malawi’s industries locally and internationally.</li>
        </ul>
      </section>
    </div>
  );
};

export default IndustrialResearchTraining;
